import React, { useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Checkbox,
  useTheme,
  Theme,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Link } from "react-router-dom";
import EditShipmentModal from "./EditShipmentsPopup";
import {
  Add as AddIcon,
  AssignmentReturn,
  Cancel,
  KeyboardReturn,
  RemoveCircle,
  Visibility,
} from "@mui/icons-material";
import { observer } from "mobx-react";
import { DeliveryPartner, Shipments } from "../../../models/Shipments";
import { EmployeeRoles } from "../../../models/Employees/EmployeeRoles";
import { useStores } from "../../../use-stores";
import AppTableHeaderCell from "../common/pages/AppTableHeaderCell";
import { SortType } from "../../../models/SortType";
import AppTableRowCell from "../common/pages/AppTableRowCell";
import { formatDate } from "../common/functions/formatDate";
import CustomTypography from "../common/form/CustomTypography";
import ViewPackProductsPopup from "../common/pop-up/ViewPackProductsPopup";
import ViewPacksPopup from "../common/pop-up/ViewPacksPopup";
import { formatName } from "../common/functions/formatString";
import { ShipmentStatusEnum } from "../../../models/Shipments/ShipmentStatus";
import dayjs from "dayjs";
import { CustomMenu, CustomMenuItem } from "../../../styles/Shipmentstyles";
interface ShipmentsTableProps {
  list: Shipments[];
  limit: number;
  page_no: number;
  total_pages: number;
  total_count: number;
  allSelected: boolean;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (limit: number) => void;
  onDelete: (shipmentId: number) => void;
  onReturned: (shipmentId: number) => void;
  // onSelectedShipmentsChange: (selectedShipments: number[]) => void;
  clearShipments: boolean;
  onSortChange: (column: string) => void;
  orderBy: string;
  orderDirection: string;
  deliveryPartners: DeliveryPartner[];
  onRemovePacks: (shipmentId: number) => void;
  onAddPacks?: (shipmentId: number) => void;
  selectedShipmentIdsMap: Map<number, number>;
  selectAllItem: () => void;
  selectItem: (shipment: Shipments) => void;
  deSelectAllItem: () => void;
  deSelectItem: (shipment: Shipments) => void;
  updateShipmentStatus: (
    shipmentId: number,
    status: ShipmentStatusEnum,
  ) => void;
}

const ShipmentsTable: React.FC<ShipmentsTableProps> = ({
  list,
  limit,
  page_no,
  total_count,
  deliveryPartners,
  // clearShipments,
  orderBy,
  orderDirection,
  allSelected,
  onSortChange,
  onPageChange,
  onRowsPerPageChange,
  onDelete,
  onReturned,
  selectedShipmentIdsMap,
  selectAllItem,
  selectItem,
  deSelectAllItem,
  deSelectItem,
  onRemovePacks,
  onAddPacks,
  updateShipmentStatus,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [isViewPackProductsPopupOpen, setIsViewPackProductsPopupOpen] =
    useState<boolean>(false);
  const [selectedPackProductsLabel, setSelectedPackProductsLabel] = useState<
    string | null | undefined
  >(null);
  const [isViewPacksPopupOpen, setIsViewPacksPopupOpen] =
    useState<boolean>(false);
  const [selectedPacksLabel, setSelectedPacksLabel] = useState<
    string | null | undefined
  >(null);

  const [selectedShipmentId, setSelectedShipmentId] = useState<number | null>(
    null,
  );
  const [selectedShipment, setSelectedShipment] = useState<Shipments>();
  const { userStore } = useStores();

  const theme = useTheme<Theme>();

  const isOpen = Boolean(anchorEl);

  const handleRequestSort = (property: string) => {
    onSortChange(property);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    onPageChange(newPage + 1);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    onPageChange(1);
    onRowsPerPageChange(parseInt(event.target.value, 10));
  };

  const handleMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    shipmentId: number,
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedShipmentId(shipmentId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedShipmentId(null);
  };

  const handleEdit = () => {
    if (selectedShipmentId !== null) {
      const shipment = list.find(
        (item: Shipments) => item.id === selectedShipmentId,
      );
      setSelectedShipment(shipment);
      setIsEditModalOpen(true);
    }
    handleMenuClose();
  };

  const handleMoveToNew = () => {
    if (selectedShipmentId !== null) {
      updateShipmentStatus(selectedShipmentId, ShipmentStatusEnum.NEW);
    }
    handleMenuClose();
  };

  const handleModalClose = () => {
    setIsEditModalOpen(false);
  };

  const handleDelete = () => {
    if (selectedShipmentId !== null) {
      onDelete(selectedShipmentId);
    }
    handleMenuClose();
  };

  const handleReturned = () => {
    if (selectedShipmentId !== null) {
      onReturned(selectedShipmentId);
    }
    handleMenuClose();
  };

  const handleRemovePacks = () => {
    if (selectedShipmentId !== null) {
      onRemovePacks(selectedShipmentId);
    }
    handleMenuClose();
  };

  const handleViewPackProducts = (
    packProductsLabel: string | null | undefined,
  ) => {
    setSelectedPackProductsLabel(packProductsLabel);
    setIsViewPackProductsPopupOpen(true);
  };

  const handleCloseViewPackProductsPopup = () => {
    setIsViewPackProductsPopupOpen(false);
    setSelectedPackProductsLabel(null);
  };

  const handleViewPacks = (packsLabel: string | null | undefined) => {
    setSelectedPacksLabel(packsLabel);
    setIsViewPacksPopupOpen(true);
  };

  const handleCloseViewPacksPopup = () => {
    setIsViewPacksPopupOpen(false);
    setSelectedPacksLabel(null);
  };

  // const areAllSelected = (): boolean => {
  //   return (
  //     selectedShipmentIdsMap.size > 0 &&
  //     selectedShipmentIdsMap.size === list.length
  //   );
  // };

  const areSomeSelected = (): boolean => {
    return (
      selectedShipmentIdsMap.size > 0 &&
      selectedShipmentIdsMap.size !== list.length
    );
  };

  const getRowBackgroundColor = (
    shipment: Shipments,
    evenOrOdd: "even" | "odd",
  ) => {
    const today = dayjs().startOf("day");

    // READY TO SHIP: status_change_date > 2 days ago → red
    if (
      shipment.status === ShipmentStatusEnum.READY_TO_SHIP &&
      shipment.status_change_date
    ) {
      const statusChangeDaysAgo = today.diff(
        dayjs(shipment.status_change_date).startOf("day"),
        "day",
      );

      if (statusChangeDaysAgo === 1) {
        const orange = theme.palette.orange?.main || "#FF8042";
        return `${orange}20`;
      } else if (statusChangeDaysAgo > 1) {
        const red = theme.palette.red?.main || "#FF0000";
        return `${red}20`;
      } else {
        const blue = theme.palette.blue?.main || "#4049B1";
        return `${blue}20`;
      }
    }

    // NEW: created_date logic
    if (shipment.status === ShipmentStatusEnum.NEW && shipment.created_date) {
      const createdDaysAgo = today.diff(
        dayjs(shipment.created_date).startOf("day"),
        "day",
      );
      if (createdDaysAgo === 1) {
        const orange = theme.palette.orange?.main || "#FF8042";
        return `${orange}20`;
      } else if (createdDaysAgo > 1) {
        const red = theme.palette.red?.main || "#FF0000";
        return `${red}20`;
      } else {
        const green = theme.palette.green?.main || "#6CBA5C";
        return `${green}20`;
      }
    }

    return evenOrOdd === "even"
      ? theme.palette.background.paper
      : theme.palette.action.hover;
  };

  return (
    <>
      <Paper
        sx={{
          marginTop: "0.6rem",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
        }}
      >
        {/* {selectedShipmentIdsMap.size > 0 && (
          <CustomTypography
            variant="heading7"
            style={{ paddingLeft: 24, paddingTop: 14 }}
          >
            {allSelected ? "" : `${selectedShipmentIdsMap.size} selected.`}
          </CustomTypography>
        )} */}

        <TableContainer sx={{ maxHeight: window.innerHeight - 340 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: theme.palette.customColors?.lightGreyColor,
                  "& th": { py: 1, height: 48 },
                }}
              >
                <AppTableHeaderCell
                  sx={{
                    textAlign: "center",
                    fontSize: 12,
                    position: "sticky",
                    left: 0,
                    zIndex: 20,
                    boxShadow: "10px 0 20px -12px rgba(115,115,115,0.3);",
                    backgroundColor: theme.palette.customColors?.lightGreyColor,
                    minWidth: "60px",
                  }}
                >
                  <Checkbox
                    color="primary"
                    indeterminate={areSomeSelected()}
                    checked={
                      allSelected === false &&
                      selectedShipmentIdsMap.size === list.length
                    }
                    onClick={() => {
                      allSelected === false &&
                      selectedShipmentIdsMap.size === list.length
                        ? deSelectAllItem()
                        : selectAllItem();
                    }}
                  />
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{
                    textAlign: "center",
                    fontSize: 12,
                    position: "sticky",
                    left: 75,
                    zIndex: 20,
                    boxShadow: "10px 0 20px -12px rgba(115,115,115,0.3);",
                    backgroundColor: theme.palette.customColors?.lightGreyColor,
                  }}
                  title="ID"
                  fontSize="12px"
                  sortColumn={"id"}
                  sortBy={orderBy}
                  sortDirection={
                    orderDirection.toLowerCase() === "asc"
                      ? SortType.ASC
                      : SortType.DESC
                  }
                  onSortChange={() => handleRequestSort("id")}
                />
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  title="Order Id"
                  sortColumn={"order_id"}
                  fontSize="12px"
                  sortBy={orderBy}
                  minWidth="120px"
                  sortDirection={
                    orderDirection.toLowerCase() === "asc"
                      ? SortType.ASC
                      : SortType.DESC
                  }
                  onSortChange={() => handleRequestSort("order_id")}
                />
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  minWidth="120px"
                  fontSize="12px"
                >
                  Inventory Id
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  minWidth="120px"
                  fontSize="12px"
                >
                  Campaign Id
                </AppTableHeaderCell>
                <AppTableHeaderCell sx={{ textAlign: "center" }} fontSize="12px">
                  Name/Email
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                >
                  Customer Name
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                  title="Placed On"
                  sortColumn={"created_date"}
                  sortBy={orderBy}
                  sortDirection={
                    orderDirection.toLowerCase() === "asc"
                      ? SortType.ASC
                      : SortType.DESC
                  }
                  onSortChange={() => handleRequestSort("created_date")}
                />
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                >
                  Last Status Change
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                >
                  Packs
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                >
                  Pack Products
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  minWidth="120px"
                  fontSize="12px"
                >
                  Order Notes
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  minWidth="120px"
                  fontSize="12px"
                >
                  Source
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  minWidth="250px"
                  fontSize="12px"
                >
                  Address
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  minWidth="120px"
                  fontSize="12px"
                >
                  Dimensions
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  minWidth="120px"
                  fontSize="12px"
                >
                  Weight
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                >
                  AWB Number
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                >
                  Delivery Partner
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                >
                  Shipping Cost
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                >
                  Size From Recipient
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                >
                  Placed By
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                >
                  Modified By
                </AppTableHeaderCell>
                <AppTableHeaderCell
                  sx={{ textAlign: "center" }}
                  fontSize="12px"
                  title="Modified Date"
                  sortColumn={"modified_date"}
                  sortBy={orderBy}
                  sortDirection={
                    orderDirection.toLowerCase() === "asc"
                      ? SortType.ASC
                      : SortType.DESC
                  }
                  onSortChange={() => handleRequestSort("modified_date")}
                />
              </TableRow>
            </TableHead>
            <TableBody>
              {list?.map((shipment: Shipments) => (
                <TableRow
                  key={shipment.id}
                  hover
                  sx={{
                    "&:nth-of-type(odd)": {
                      backgroundColor: getRowBackgroundColor(shipment, "odd"),
                    },
                    "&:nth-of-type(even)": {
                      backgroundColor: getRowBackgroundColor(shipment, "even"),
                    },
                    "& td": { fontSize: "12px" },
                  }}
                >
                  <AppTableRowCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      zIndex: 12,
                      backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    <Checkbox
                      color="primary"
                      checked={
                        selectedShipmentIdsMap.get(shipment.id) !== undefined
                      }
                      onClick={() => {
                        if (selectedShipmentIdsMap.get(shipment.id)) {
                          deSelectItem(shipment);
                        } else {
                          selectItem(shipment);
                        }
                      }}
                    />
                  </AppTableRowCell>
                  <AppTableRowCell
                    sx={{
                      textAlign: "center",
                      position: "sticky",
                      left: 75,
                      zIndex: 10,
                      boxShadow: "10px 0 20px -12px rgba(115,115,115,0.3);",
                      backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    {shipment.id}
                  </AppTableRowCell>
                  <AppTableRowCell>{shipment.order_id || "-"}</AppTableRowCell>
                  <AppTableRowCell>
                    {shipment.inventory_id || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {shipment.campaign_id || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell minWidth="250px">
                    {`${formatName(shipment.first_name) + " " + formatName(shipment.last_name)}`}
                    <br />
                    {shipment.email?.toLowerCase() || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell minWidth="200px">
                    {shipment.customer_name}
                  </AppTableRowCell>
                  <AppTableRowCell minWidth="150px">
                    {formatDate(shipment.created_date, false, true)}
                  </AppTableRowCell>
                  <AppTableRowCell minWidth="150px">
                    {formatDate(shipment.status_change_date, false, true)}
                  </AppTableRowCell>
                  <AppTableRowCell minWidth="250px">
                    {shipment.packs_label ? (
                      <Box
                        component="span"
                        onClick={() => handleViewPacks(shipment.packs_label)}
                        sx={{
                          cursor: "pointer",
                          color: theme.palette.primary.main,
                          textDecoration: "underline",
                          "&:hover": { textDecoration: "underline" },
                        }}
                      >
                        {shipment.packs_label.length > 50
                          ? `${shipment.packs_label.slice(0, 50)}...`
                          : shipment.packs_label}
                      </Box>
                    ) : onAddPacks &&
                      userStore.hasPermission(EmployeeRoles.EDIT_SHIPMENTS) ? (
                      <IconButton
                        onClick={() => onAddPacks(shipment.id)}
                        size="small"
                        sx={{
                          color: theme.palette.primary.main,
                          "&:hover": {
                            backgroundColor: `${theme.palette.primary.main}20`,
                          },
                        }}
                        title="Add Pack"
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>
                    ) : (
                      "-"
                    )}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {shipment.pack_products_label ? (
                      <IconButton
                        onClick={() =>
                          handleViewPackProducts(shipment.pack_products_label)
                        }
                        size="small"
                        sx={{
                          color: theme.palette.customColors.greyTextColor,
                          "&:hover": {
                            backgroundColor: `${theme.palette.customColors.greyTextColor}20`,
                          },
                        }}
                        title="View Packs"
                      >
                        <Visibility fontSize="small" />
                      </IconButton>
                    ) : (
                      "-"
                    )}
                  </AppTableRowCell>
                  <AppTableRowCell minWidth="250px">
                    {shipment.order_notes || "-"}{" "}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {shipment.shipment_type_label || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell minWidth="250px">
                    {[
                      shipment.city,
                      shipment.state,
                      shipment.country,
                      shipment.pincode,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {shipment.length && `${shipment.length}`}
                    {shipment.length && shipment.breadth && ` * `}
                    {shipment.breadth && `${shipment.breadth}`}
                    {shipment.breadth && shipment.height && ` * `}
                    {shipment.height && `${shipment.height}`}
                  </AppTableRowCell>
                  <AppTableRowCell>{shipment.weight || "-"}</AppTableRowCell>
                  <AppTableRowCell>
                    {shipment.awb_track_url ? (
                      <Link to={shipment.awb_track_url} target="_blank">
                        {shipment.awb}
                      </Link>
                    ) : (
                      shipment.awb || "-"
                    )}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {shipment.delivery_partner_name || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {shipment.shipping_cost || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {" "}
                    {shipment.size_from_recipient || "-"}{" "}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {shipment.placed_by_admin_name || "-"}{" "}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {shipment.modified_by_name || "-"}{" "}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {formatDate(shipment.modified_date)}
                  </AppTableRowCell>

                  {userStore.hasPermission(EmployeeRoles.EDIT_SHIPMENTS) && (
                    <AppTableRowCell
                      sx={{
                        textAlign: "center",
                        width: "10%",
                        position: "sticky",
                        right: 0,
                        zIndex: 8,
                        backgroundColor: theme.palette.background.paper,
                      }}
                    >
                      <IconButton
                        onClick={(event) => handleMenuClick(event, shipment.id)}
                        size="small"
                        sx={{
                          color: theme.palette.customColors.greyTextColor,
                          "&:hover": {
                            backgroundColor: `${theme.palette.customColors.greyTextColor}20`,
                          },
                        }}
                      >
                        <MoreVertIcon />
                      </IconButton>

                      <CustomMenu
                        anchorEl={anchorEl}
                        open={isOpen}
                        onClose={handleMenuClose}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <CustomMenuItem onClick={handleEdit}>
                          <EditIcon
                            sx={{ marginRight: 1, fontSize: "0.9rem" }}
                          />{" "}
                          <CustomTypography variant="body2">
                            Edit
                          </CustomTypography>
                        </CustomMenuItem>
                        {(shipment.status === ShipmentStatusEnum.RETURNED ||
                          shipment.status === ShipmentStatusEnum.CANCELLED ||
                          shipment.status === ShipmentStatusEnum.UNDELIVERED ||
                          shipment.status ===
                            ShipmentStatusEnum.RETURN_REQUESTED) && (
                          <CustomMenuItem onClick={handleMoveToNew}>
                            <KeyboardReturn
                              sx={{ marginRight: 1, fontSize: "0.9rem" }}
                            />{" "}
                            <CustomTypography variant="body2">
                              Move to New
                            </CustomTypography>
                          </CustomMenuItem>
                        )}
                        {userStore.hasPermission(
                          EmployeeRoles.REMOVE_PACK_FROM_USER_PLACED_SHIPMENTS,
                        ) && (
                          <CustomMenuItem onClick={handleRemovePacks}>
                            <RemoveCircle
                              sx={{ marginRight: 1, fontSize: "0.9rem" }}
                            />{" "}
                            <CustomTypography variant="body2">
                              Remove Packs
                            </CustomTypography>
                          </CustomMenuItem>
                        )}
                        {userStore.hasPermission(
                          EmployeeRoles.CANCEL_USER_PLACED_SHIPMENTS,
                        ) && (
                          <CustomMenuItem onClick={handleDelete}>
                            <Cancel
                              sx={{ marginRight: 1, fontSize: "0.9rem" }}
                            />{" "}
                            <CustomTypography variant="body2">
                              Cancel
                            </CustomTypography>
                          </CustomMenuItem>
                        )}
                        {userStore.hasPermission(
                          EmployeeRoles.CANCEL_USER_PLACED_SHIPMENTS,
                        ) && (
                          <CustomMenuItem onClick={handleReturned}>
                            <AssignmentReturn
                              sx={{ marginRight: 1, fontSize: "0.9rem" }}
                            />{" "}
                            <CustomTypography variant="body2">
                              Mark Returned
                            </CustomTypography>
                          </CustomMenuItem>
                        )}
                      </CustomMenu>
                    </AppTableRowCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {list?.length === 0 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              p: 4,
              borderTop: "1px solid",
              borderColor: "divider",
              backgroundColor:
                theme.palette.customColors?.grayBackGroundColor ||
                theme.palette.action.hover,
            }}
          >
            <CustomTypography
              variant="heading6"
              fontWeight={600}
              color={theme.palette.customColors?.greyTextColor}
            >
              No shipments match the current filters.
            </CustomTypography>
          </Box>
        )}
        {total_count > 0 && (
          <TablePagination
            rowsPerPageOptions={[30, 50, 100, 200, 500]}
            component="div"
            count={total_count}
            rowsPerPage={limit}
            page={page_no - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              borderTop: "1px solid",
              borderColor: "divider",
              backgroundColor: theme.palette.background.paper,
              "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                {
                  fontSize: "0.8rem",
                  color: theme.palette.customColors?.greyTextColor,
                },
            }}
          />
        )}
      </Paper>
      {selectedShipment && (
        <EditShipmentModal
          open={isEditModalOpen}
          onClose={handleModalClose}
          shipment={selectedShipment}
          deliveryPartners={deliveryPartners}
        />
      )}
      <ViewPackProductsPopup
        open={isViewPackProductsPopupOpen}
        packProductsLabel={selectedPackProductsLabel}
        onClose={handleCloseViewPackProductsPopup}
      />
      <ViewPacksPopup
        open={isViewPacksPopupOpen}
        packsLabel={selectedPacksLabel}
        onClose={handleCloseViewPacksPopup}
      />
    </>
  );
};

export default observer(ShipmentsTable);
